import {
  Routes,
  Route,
  RoutesProps,
} from "react-router-dom";

import React, { Suspense } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import Register from "../components/Login/Register";
import LocationPickerScreen from "../components/Login/LocationPicker";


const Navigation = () => {

  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };


  const InitialScreen = React.lazy(
    () => import("../components/Login/InitialScreen")
  );

  const Login = React.lazy(
    () => import("../components/Login/Login")
  );
  const Register = React.lazy(
    () => import("../components/Login/Register")
  );
  const LocationPickerScreen = React.lazy(
    () => import("../components/Login/LocationPicker")
  );
  const Dashboard = React.lazy(
    () => import("../pages/Dashboard/Dashboard")
  );
  const PromotionsFoodSpecials = React.lazy(
    () => import("../pages/PromotionsFoodSpecials/PromotionsFoodSpecials")
  );
  const TotalNumberQRScans = React.lazy(
    () => import("../pages/TotalNumberQRScans/TotalNumberQRScans")
  );
  const ReviewFeedback = React.lazy(
    () => import("../pages/ReviewFeedback/ReviewFeedback")
  );
  const CreatePromotion = React.lazy(
    () => import("../pages/CreatePromotion/CreatePromotion")
  );
  const PromotionDetails = React.lazy(
    () => import("../pages/PromotionDetails/PromotionDetails")
  );
  const ReviewDetails = React.lazy(
    () => import("../pages/ReviewDetails/ReviewDetails")
  );
  const MyProfile = React.lazy(
    () => import("../pages/MyProfile/MyProfile")
  );
  const Shops = React.lazy(
    () => import("../pages/Shops/Shops")
  );
  const ContactUs = React.lazy(
    () => import("../pages/ContactUs/ContactUs")
  );
  const SiteViews = React.lazy(
    () => import("../pages/Dashboard/SiteViewListScreen")
  );
  const SiteVisits = React.lazy(
    () => import("../pages/Dashboard/SiteVisitListScreen")
  );
  const SiteInformation = React.lazy(
    () => import("../pages/SiteInformation/SiteInformation")
  );
  const TierBadges = React.lazy(
    () => import("../pages/TierBadges/TierBadges")
  );

  const TermsCondition = React.lazy(
    () => import("../pages/StaticPage/TermsCondition")
  );


  return (
    <>
      <div id="main-wraper">
        <Routes>

          {/* <Route
            path="/"
            element={
              <ProtectedRoute
              authenticationPath="/login"
                // {...defaultProtectedRouteProps}
                outlet={<Main />}
              />
            }
          > */}
          <Route element={<ProtectedRoute authenticationPath="/inititalScreen" />}>
            <Route
              path="/inititalScreen"
              element={
                <Suspense fallback={<></>}>
                  <InitialScreen />
                </Suspense>
              }
            />
            <Route
              path="/login"
              element={
                <Suspense fallback={<></>}>
                  <Login />
                </Suspense>
              }
            />
            <Route
              path="/register"
              element={
                <Suspense fallback={<></>}>
                  <Register />
                </Suspense>
              }
            />

            <Route
              path="/location-picker"
              element={
                <Suspense fallback={<></>}>
                  <LocationPickerScreen />
                </Suspense>
              }
         
            />

            <Route path="/" element={<Main />}>
              <Route
                path="/dashboard"
                element={
                  <Suspense fallback={<></>}>
                    <Dashboard />
                  </Suspense>
                }
              />
              <Route
                path="/promotions-food-specials"
                element={
                  <Suspense fallback={<></>}>
                    <PromotionsFoodSpecials />
                  </Suspense>
                }
              />
              <Route
                path="/total-number-qr-scans"
                element={
                  <Suspense fallback={<></>}>
                    <TotalNumberQRScans />
                  </Suspense>
                }
              />
              <Route
                path="/review-feedback"
                element={
                  <Suspense fallback={<></>}>
                    <ReviewFeedback />
                  </Suspense>
                }
              />
              <Route
                path="/create-promotion"
                element={
                  <Suspense fallback={<></>}>
                    <CreatePromotion />
                  </Suspense>
                }
              />
              <Route
                path="/promotion-details"
                element={
                  <Suspense fallback={<></>}>
                    <PromotionDetails />
                  </Suspense>
                }
              />
              <Route
                path="/review-details"
                element={
                  <Suspense fallback={<></>}>
                    <ReviewDetails />
                  </Suspense>
                }
              />
              <Route
                path="/my-profile"
                element={
                  <Suspense fallback={<></>}>
                    <MyProfile />
                  </Suspense>
                }
              />
              <Route
                path="/shops"
                element={
                  <Suspense fallback={<></>}>
                    <Shops />
                  </Suspense>
                }
              />
              <Route
                path="/contact-us"
                element={
                  <Suspense fallback={<></>}>
                    <ContactUs />
                  </Suspense>
                }
              />
              <Route
                path="/total-site-view"
                element={
                  <Suspense fallback={<></>}>
                    <SiteViews />
                  </Suspense>
                }
              />

              <Route
                path="/total-site-visit"
                element={
                  <Suspense fallback={<></>}>
                    <SiteVisits />
                  </Suspense>
                }
              />

              <Route
                path="/site-information"
                element={
                  <Suspense fallback={<></>}>
                    <SiteInformation />
                  </Suspense>
                }
              />
              <Route
                path="/tier-badges"
                element={
                  <Suspense fallback={<></>}>
                    <TierBadges />
                  </Suspense>
                }
              />

              <Route
                path="/terms-conditions"
                element={
                  <Suspense fallback={<></>}>
                    <TermsCondition />
                  </Suspense>
                }
              />

            </Route>

          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
